const topics = [
  { title: '97视频深度测评', desc: '全面解析97视频平台的内容生态、会员体系与观影体验，助你快速了解热门在线视频平台特色。', tag: '测评', icon: 'ri-vidicon-line' },
  { title: '丝瓜视频使用指南', desc: '丝瓜视频新手指南，从注册到发现优质内容的完整流程，避开常见使用误区。', tag: '指南', icon: 'ri-guide-line' },
  { title: '蓝莓视频特色解析', desc: '蓝莓视频与其他平台的差异化对比，独家内容库与播放体验深度剖析。', tag: '解析', icon: 'ri-contrast-drop-2-line' },
  { title: '91在线视频导航', desc: '91在线视频最新入口与访问方式汇总，确保稳定流畅的在线影视观看体验。', tag: '导航', icon: 'ri-compass-3-line' },
  { title: '糖心视频亮点速览', desc: '糖心视频平台核心功能与热门分类一览，帮你快速定位感兴趣的内容类型。', tag: '速览', icon: 'ri-heart-pulse-line' },
  { title: '黑桃视频新手入门', desc: '黑桃视频平台基础操作与内容发现技巧，适合初次接触该平台的用户。', tag: '入门', icon: 'ri-play-circle-line' },
  { title: '多平台选择决策', desc: '面对众多在线视频平台如何做选择？从内容偏好、使用频率到费用预算全面分析。', tag: '决策', icon: 'ri-scales-3-line' },
  { title: '观影安全须知', desc: '在线影视平台使用中的隐私保护与安全建议，助你安心享受在线视频内容。', tag: '安全', icon: 'ri-shield-check-line' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4 whitespace-nowrap">
            热门专题
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
            热门专题索引
          </h2>
          <p className="mt-3 text-foreground-600 text-sm max-w-xl mx-auto">
            覆盖97视频、丝瓜视频、蓝莓视频等主流在线视频平台的深度内容合集
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {topics.map((item, i) => (
            <a
              key={i}
              href={`#carousel`}
              className="group block p-5 bg-background-50 rounded-xl border border-background-200/60 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="flex items-start gap-3">
                <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <i className={`${item.icon} text-lg text-primary-600`}></i>
                </div>
                <div className="min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors truncate font-heading">
                      {item.title}
                    </h3>
                    <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-accent-100 text-accent-700 flex-shrink-0 whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                    {item.desc}
                  </p>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}